


















































import Vue, { PropType } from 'vue'

declare interface Summary {
  playerName: string,
  finalScore: number,
}

export default Vue.extend({
  name: 'DialogSummaryWithFriends',

  props: {
    dialogSummary: Boolean,
    summaryTexts: Array as PropType<Summary[]>,
    score: Number,
  },

  methods: {
    updateRecord(): void {
      let currentRecord = Number(localStorage.getItem('record'))
      if (currentRecord == null || this.score < currentRecord) {
        localStorage.setItem('record', String(this.score))
      }
    },

    finishGame(): void {
      this.$emit('finishGame')
    },      
  },

  watch: {
    dialogSummary: function(newVal: boolean, oldVal: boolean): void {
      if (newVal === true) {
        this.updateRecord()
      }
    }      
  },
})
